import React from "react";
import TopGallery from "../components/sellWithUs/content/topGallery/TopGallery";
import OurTools from "../components/sellWithUs/content/layout/OurTools";
import TransparentProcess from "../components/sellWithUs/content/transparentProcess/TransparentProcess";
import WhyChooseUs from "../components/sellWithUs/content/layout/WhyChooseUs";
import OurPartners from "../components/sellWithUs/content/layout/OurPartners";
import { Header } from "../components/_shared/Header";
import { Navbar } from "../components/_shared/Navbar";
import { FooterSocialMediaLine } from "../components/_shared/FooterSocialMediaLine";
import { FooterDemo } from "../components/_shared/FooterDemo";
import { AuthPopup } from "../components/_shared/AuthPopup";
import { SideNavMenu } from "../components/_shared/SideNavMenu";
import GetInTouchFooter from "../components/sellWithUs/content/layout/GetInTouchFooter";
import Questions from "../components/sellWithUs/content/layout/Questions";
import Testimonials from "../components/sellWithUs/content/layout/Testimonials";

export default function SellWithUs() {
  return (
    <div
      style={{
        overflow: "visible",
      }}
    >
      <div className="portfolio-header-sticky-wrapper">
        <div
          style={{
            backgroundColor: "rgba(255, 255, 255, 1)",
          }}
        >
          <Header>
            <Navbar />
          </Header>
        </div>
      </div>
      <TopGallery />
      <WhyChooseUs />
      <OurTools />
      <TransparentProcess />
      <Testimonials/>
      <OurPartners />
      <Questions />
      <GetInTouchFooter />
      {/* <Footer /> */}
      <FooterDemo />
      <FooterSocialMediaLine />
      <AuthPopup />
      <SideNavMenu />
    </div>
  );
}
